import { useState } from "react";
import { Grid } from "@mui/material";
import { Stack } from "@financeable-com-au/financeable-ui";
import { AssetSupplierProps } from "@/utils/interface";
// @ts-expect-error: ignoring as it is existing js file
import PhoneNumber from "../CustomerDetails/PhoneNumber";
import FormInputField from "../CommonComponents/FormInputField";

const AssetSupplier = ({
  applicationId,
  handle,
  allValues,
  isDisableEdit,
  getLocalAndLenderError,
}: AssetSupplierProps) => {
  const [fieldErrors, setFieldErrors] = useState({
    supplierPhone: "",
  });

  return (
    <Stack>
      <Stack spacing={1} direction="row" style={{ margin: "0 0 10px" }}>
        <FormInputField
          fieldName="supplierName"
          label="Supplier Name"
          value={allValues?.supplierName}
          error={getLocalAndLenderError({ fieldName: "supplierName" })}
          gridProps={{ md: 6, sm: 6 }}
          onChange={handle.onChangeField}
          onBlur={handle.blurFn}
          disabled={isDisableEdit}
        />

        <FormInputField
          fieldName="supplierContactName"
          label="Contact Name"
          value={allValues?.supplierContactName}
          error={getLocalAndLenderError({ fieldName: "supplierContactName" })}
          gridProps={{ md: 6, sm: 6 }}
          onChange={handle.onChangeField}
          onBlur={handle.blurFn}
          disabled={isDisableEdit}
        />
      </Stack>

      <Stack spacing={1} direction="row" style={{ margin: "0 0 10px" }}>
        <FormInputField
          fieldName="supplierEmail"
          label="Email"
          value={allValues?.supplierEmail}
          error={getLocalAndLenderError({ fieldName: "supplierEmail" })}
          gridProps={{ md: 6, sm: 6 }}
          onChange={handle.onChangeField}
          onBlur={handle.blurFn}
          disabled={isDisableEdit}
        />
        <Grid item md={6} sm={6}>
          <PhoneNumber
            label={"Phone number"}
            fieldKey="supplierPhone"
            guarantorFieldErrors={fieldErrors}
            setGuarantorFieldErrors={setFieldErrors}
            saveContactNum={(key: string, value: string) => handle.blurFn(key, value)}
            phoneNumber={allValues?.supplierPhone}
            onValueChange={(value: string) => handle.onChangeField(value, "supplierPhone")}
            applicationId={applicationId}
            isOutlined={true}
            disabled={isDisableEdit}
          />
        </Grid>
      </Stack>

      <Stack spacing={1} direction="row" style={{ margin: "0 0 10px" }}>
        <FormInputField
          fieldName="supplierABN"
          label="ABN"
          value={allValues?.supplierABN}
          error={getLocalAndLenderError({ fieldName: "supplierABN" })}
          gridProps={{ md: 4, sm: 4 }}
          onChange={handle.onChangeField}
          onBlur={handle.blurFn}
          disabled={isDisableEdit}
        />

        <FormInputField
          fieldName="supplierAddress"
          label="Address"
          value={allValues?.supplierAddress}
          error={getLocalAndLenderError({ fieldName: "supplierAddress" })}
          gridProps={{ md: 8, sm: 8 }}
          onChange={handle.onChangeField}
          onBlur={handle.blurFn}
          disabled={isDisableEdit}
        />
      </Stack>
    </Stack>
  );
};

export default AssetSupplier;
